import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {TeamValues} from './TeamValues';
import {EmpionMatchScoresGrid} from '../../../../../../../components/EmpionMatchScoresGrid/EmpionMatchScoresGrid';
import {MatchData} from '../../../../../../../types/shared-recruiting-types';

interface Props {
  match: MatchData;
  /** Default 5; use a smaller value when nothing (e.g. actions) sits between header and fit. */
  marginTop?: number;
  /** When false, hide the score breakdown card (e.g. talent pool profile — scores live per application). */
  showScoreCards?: boolean;
  /** Controls layout of score and team-value cards for reuse across page/dialog contexts. */
  layout?: 'row' | 'stack';
}

export const MatchFit = ({match, marginTop = 5, showScoreCards = true, layout = 'row'}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'matchDetailsPage.matchFit'});
  const {t: tTable} = useTranslation('translation', {keyPrefix: 'matchesPage.tableColumns'});
  const scoreBreakdownItems = [
    {
      key: 'total',
      label: tTable('total'),
      value: `${match.matchInformationOverview?.overallScore || 0}%`,
    },
    {
      key: 'job',
      label: tTable('job'),
      value: `${match.matchInformationOverview?.jobMatchScore || 0}%`,
    },
    {
      key: 'test',
      label: tTable('test'),
      value: `${match.matchInformationOverview?.assessmentScore || 0}%`,
    },
    {
      key: 'culture',
      label: tTable('culture'),
      value: `${match.matchInformationOverview?.culturalMatchScore || 0}%`,
    },
  ];
  return (
    <Box marginTop={marginTop}>
      <Typography variant='h2'>{t('title')}</Typography>
      {showScoreCards ? (
        <Box sx={{mt: 1.5, mb: 2, display: 'flex', justifyContent: 'flex-start'}}>
          <EmpionMatchScoresGrid
            ariaLabel={`${tTable('total')}, ${tTable('job')}, ${tTable('test')}, ${tTable('culture')}`}
            items={scoreBreakdownItems}
            variant='default'
          />
        </Box>
      ) : null}
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          alignItems: 'stretch',
          flexDirection: layout === 'stack' ? 'column' : 'row',
          flexWrap: 'nowrap',
          '& > *': {
            width: layout === 'stack' ? '100%' : 'auto',
          },
        }}
      >
        <TeamValues
          cultureTypeInfo={match.applicant?.cultureType}
          talentFirstName={match.applicant?.personalInformation?.firstName}
        />
      </Box>
    </Box>
  );
};
